<template>
  <div
    class="maintenance-status-card avoid-break"
    :class="`maintenance-status-card--${group.status}`"
  >
    <div class="maintenance-status-card__description">
      {{ group.description }}
    </div>
    <div
      class="maintenance-status-card__status"
      :class="group.status"
    >
      {{ groupStatus }}
    </div>
    <div class="maintenance-status-card__time-wrapper">
      <div class="maintenance-status-card__expected-date-wrapper">
        <label class="maintenance-status-card__expected-date-label m-0">
          {{ $t('engineering.cooling-maintenance.expected-date') }}
        </label>
        <div class="maintenance-status-card__expected-date">
          <date-time-label
            v-if="group.expectedDate"
            :format="dateLabelFormat"
            :class="group.status"
            :value="group.expectedDate"
          />
          <span v-else> - </span>
        </div>
      </div>
      <div class="maintenance-status-card__days-wrapper">
        <label class="maintenance-status-card__days-label m-0">
          {{ $t('general.days') }}
        </label>
        <div
          class="maintenance-status-card__days"
          :id="`group-${group.id}-days`"
          :class="group.status"
        >
          {{ groupExpectedDays }}
        </div>
        <b-tooltip
          v-if="showDaysTooltip"
          triggers="hover"
          placement="bottom"
          :target="`group-${group.id}-days`"
        >
          {{ group.daysForMaintenance }}
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { formats } from '@/constants/localizer';

export default {
  name: 'MaintenanceStatusCard',
  props: {
    group: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    groupStatus() {
      const { status } = this.group;
      return status ? this.$t(`enums.engineering.maintenance-status.${status}`) : '-';
    },
    showDaysTooltip() {
      const { daysForMaintenance } = this.group;
      return daysForMaintenance > 99 || daysForMaintenance < -99;
    },
    groupExpectedDays() {
      const { daysForMaintenance } = this.group;
      if (daysForMaintenance == null) return '-';
      if (daysForMaintenance > 99) {
        return '+99';
      }
      if (daysForMaintenance < -99) {
        return '-99';
      }
      return daysForMaintenance;
    },
  },
  data: () => ({
    dateLabelFormat: formats.DATE_SHORT,
  }),
};
</script>

<style lang="sass" scoped>

$danger: var(--color-danger)

.maintenance-status-card
  min-height: 150px
  border: 1px solid var(--color-border-dark)
  border-radius: 5px
  display: flex
  padding: 10px
  flex-direction: column
  justify-content: space-between
  align-items: center
  &--in-day
    border: 1px solid var(--color-border-dark)
  &--imminent
    border: 1px solid var(--color-warning)
  &--delayed
    border: none
    box-shadow: 0 0 3px $danger, inset 0 0 3px $danger !important
  &__description
    font-weight: bold
    font-size: 1.3em
    text-align: center
  &__status
    font-weight: bold
    font-size: 1.6em
  &__time-wrapper
    display: flex
    justify-content: space-between
    width: 100%
  &__expected-date-wrapper,
  &__days-wrapper
    display: inline-flex
    flex-direction: column
    align-items: center
  &__expected-date,
  &__days
    font-size: 1.1em
  &__expected-date-label,
  &__days-label
    font-size: 0.95em
  .in-day
    color: var(--color-primary)
  .imminent
    color: var(--color-warning)
  .delayed
    color: $danger
  @media print
    width: 23%
    margin: 1%
    display: inline-flex
</style>
